import { render } from "./Booking_Restaurant.vue?vue&type=template&id=18c31568&scoped=true"
import script from "./Booking_Restaurant.vue?vue&type=script&lang=js"
export * from "./Booking_Restaurant.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-18c31568"

export default script